
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import {dictApi, fileApi, measuringStandardApi, userApi} from "@/api/organization";
    import SetTableColumns from "@/components/SetTableColumns.vue";

    @Component({
        components: {SetTableColumns}
    })
    export default class MeasuringList extends Vue {
        title = "计量标准列表";
        listData = [] as any;
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        tabCol = [];
        tableKey = 0;

        /**
         * 要查询的器具id
         * */
        @Prop() private id!: any;

        created() {
            this.getConfig();
        }
        indexMethod(index: any) {
            return (this.listParam.current-1)*this.listParam.size+index+1;
        }
        getConfig() {
            userApi.getUserConfig({name: "measuringDialogPageSize"}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                    this.list();
                }
            })
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }

        list() {
            const params = {
                instrumentId: this.id,
                ...this.listParam,
            }
            measuringStandardApi.listMeasuringStandardByInstrumentId(params).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.listData = rData;
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                    })
                }
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.listParam.current = 1;
            this.list();
            userApi.updateUserConfig({name: "measuringDialogPageSize", config: val})
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }
    }
